import { defineStore } from 'pinia'
import * as Api from './api'
import {
  callWithMeta,
  createMeta,
  getMetaInitial,
  waitFor,
  type Meta,
} from '@/utils/store'

type Tariff = any

type State = {
  possibleTariffs: Tariff[]
  meta: Meta<{ possibleTariffs: undefined; loadTariffs: undefined }>
}

const getDefaultState = (): State => ({
  possibleTariffs: [],
  meta: createMeta(['possibleTariffs', 'loadTariffs']),
})

export const useTariffsStore = defineStore('tariffs', {
  state: getDefaultState,

  getters: {
    get: (state) => state.possibleTariffs,
  },

  actions: {
    RESET() {
      this.possibleTariffs = []
      this.meta.possibleTariffs = getMetaInitial()
    },

    async loadTariffs({ useCache = true } = {}) {
      const hasCached = ['pending', 'success'].includes(
        this.meta.possibleTariffs.status
      )

      if (useCache && hasCached) {
        await waitFor(() => this.meta.possibleTariffs.status !== 'pending')

        return this.possibleTariffs
      }

      const { result } = await callWithMeta({
        store: this,
        metaFields: { possibleTariffs: undefined, loadTariffs: undefined },
        apiCall: async () => await Api.loadTariffs(),
        onSuccess: ({ result, isLatest }) => {
          if (isLatest('possibleTariffs')) {
            this.possibleTariffs = result.payload
          }
        },
      })

      if (result.status === 'success') {
        return result.payload
      }

      throw result.payload
    },
  },
})
